import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { DashboardLayout } from '../DashboardLayout';
import { Button } from '../../ui';
import { ArrowLeftIcon, SparklesIcon, SendIcon, EyeIcon, PaletteIcon, ImageIcon, CheckCircle2Icon, DownloadIcon } from 'lucide-react';
export function ProposalBuilderPage() {
  const [primary, setPrimary] = useState('#0B1B3B');
  const [accent, setAccent] = useState('#FF6B4A');
  const [brandName, setBrandName] = useState('Coral Bay Resort & Spa');
  const [sent, setSent] = useState(false);
  return <DashboardLayout pageTitle="AI Proposal Builder" breadcrumb="Client Book / Proposal" data-id="element-1025">
      <Link to="/dashboard/clients/c1" className="inline-flex items-center gap-1 text-sm text-slate-500 hover:text-brand-navy mb-6" data-id="element-1026">
        <ArrowLeftIcon className="w-4 h-4" data-id="element-1027" /> Back to client
      </Link>

      <div className="grid lg:grid-cols-[400px_1fr] gap-6" data-id="element-1028">
        {/* Left: branding controls */}
        <div className="space-y-5" data-id="element-1029">
          <div className="bg-white rounded-2xl border border-slate-200 shadow-soft p-5" data-id="element-1030">
            <div className="flex items-center gap-2 mb-4" data-id="element-1031">
              <SparklesIcon className="w-4 h-4 text-brand-coral" data-id="element-1032" />
              <h3 className="font-bold text-brand-navy text-sm uppercase tracking-wider" data-id="element-1033">
                Recipient
              </h3>
            </div>
            <div className="bg-slate-50 rounded-lg p-3 text-sm" data-id="element-1034">
              <div className="font-bold text-brand-navy" data-id="element-1035">Northwind Capital</div>
              <div className="text-slate-500 text-xs" data-id="element-1036">
                Erin Park · erin.park@northwindcap.com
              </div>
            </div>
          </div>

          <div className="bg-white rounded-2xl border border-slate-200 shadow-soft p-5" data-id="element-1037">
            <div className="flex items-center gap-2 mb-4" data-id="element-1038">
              <PaletteIcon className="w-4 h-4 text-brand-teal" data-id="element-1039" />
              <h3 className="font-bold text-brand-navy text-sm uppercase tracking-wider" data-id="element-1040">
                Your branding
              </h3>
            </div>

            <div className="space-y-4" data-id="element-1041">
              <div data-id="element-1042">
                <label className="block text-xs font-bold text-slate-600 mb-1.5" data-id="element-1043">
                  Brand name
                </label>
                <input value={brandName} onChange={e => setBrandName(e.target.value)} className="w-full px-3 py-2 border border-slate-200 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-brand-teal/20 focus:border-brand-teal" data-id="element-1044" />
              </div>

              <div data-id="element-1045">
                <label className="block text-xs font-bold text-slate-600 mb-1.5" data-id="element-1046">
                  Logo
                </label>
                <button className="w-full border-2 border-dashed border-slate-200 rounded-lg p-4 flex items-center gap-3 hover:border-brand-teal hover:bg-brand-teal/5 transition-colors text-left" data-id="element-1047">
                  <ImageIcon className="w-5 h-5 text-slate-400" data-id="element-1048" />
                  <span className="text-sm text-slate-500" data-id="element-1049">
                    Upload logo (PNG/SVG)
                  </span>
                </button>
              </div>

              <div className="grid grid-cols-2 gap-3" data-id="element-1050">
                <div data-id="element-1051">
                  <label className="block text-xs font-bold text-slate-600 mb-1.5" data-id="element-1052">
                    Primary color
                  </label>
                  <div className="flex items-center gap-2 border border-slate-200 rounded-lg px-3 py-2" data-id="element-1053">
                    <input type="color" value={primary} onChange={e => setPrimary(e.target.value)} className="w-6 h-6 rounded cursor-pointer border-none" data-id="element-1054" />
                    <input value={primary} onChange={e => setPrimary(e.target.value)} className="flex-1 text-xs font-mono outline-none bg-transparent" data-id="element-1055" />
                  </div>
                </div>
                <div data-id="element-1056">
                  <label className="block text-xs font-bold text-slate-600 mb-1.5" data-id="element-1057">
                    Accent color
                  </label>
                  <div className="flex items-center gap-2 border border-slate-200 rounded-lg px-3 py-2" data-id="element-1058">
                    <input type="color" value={accent} onChange={e => setAccent(e.target.value)} className="w-6 h-6 rounded cursor-pointer border-none" data-id="element-1059" />
                    <input value={accent} onChange={e => setAccent(e.target.value)} className="flex-1 text-xs font-mono outline-none bg-transparent" data-id="element-1060" />
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="bg-white rounded-2xl border border-slate-200 shadow-soft p-5" data-id="element-1061">
            <h3 className="font-bold text-brand-navy text-sm uppercase tracking-wider mb-4" data-id="element-1062">
              Proposal contents
            </h3>
            <div className="space-y-2" data-id="element-1063">
              {[{
              label: 'Cover & branded greeting',
              on: true
            }, {
              label: 'Recommended experience pathway',
              on: true
            }, {
              label: 'Wellness add-on layer',
              on: true
            }, {
              label: 'Sample agenda preview',
              on: true
            }, {
              label: 'Investment & inclusions',
              on: true
            }, {
              label: 'Post-event reporting preview',
              on: false
            }, {
              label: 'Case study from similar client',
              on: false
            }].map(s => <label key={s.label} className="flex items-center gap-3 p-2 rounded-lg hover:bg-slate-50 cursor-pointer" data-id="element-1064">
                  <input type="checkbox" defaultChecked={s.on} className="w-4 h-4 rounded text-brand-teal focus:ring-brand-teal" data-id="element-1065" />
                  <span className="text-sm text-slate-700" data-id="element-1066">{s.label}</span>
                </label>)}
            </div>
          </div>

          <div className="space-y-2" data-id="element-1067">
            <Button variant="primary" className="w-full" onClick={() => setSent(true)} data-id="element-1068">
              <SendIcon className="w-4 h-4 mr-2" data-id="element-1069" /> Send proposal to Erin
            </Button>
            <div className="grid grid-cols-2 gap-2" data-id="element-1070">
              <Button variant="outline" size="sm" data-id="element-1071">
                <EyeIcon className="w-4 h-4 mr-2" data-id="element-1072" /> Preview
              </Button>
              <Button variant="outline" size="sm" data-id="element-1073">
                <DownloadIcon className="w-4 h-4 mr-2" data-id="element-1074" /> PDF
              </Button>
            </div>
          </div>
        </div>

        {/* Right: live preview */}
        <div data-id="element-1075">
          {sent ? <motion.div initial={{
          opacity: 0,
          scale: 0.96
        }} animate={{
          opacity: 1,
          scale: 1
        }} className="bg-white rounded-2xl border border-slate-200 shadow-soft p-12 text-center" data-id="element-1076">
              <div className="w-16 h-16 mx-auto mb-5 rounded-full bg-emerald-100 text-emerald-600 flex items-center justify-center" data-id="element-1077">
                <CheckCircle2Icon className="w-8 h-8" data-id="element-1078" />
              </div>
              <h2 className="text-2xl font-bold text-brand-navy mb-2" data-id="element-1079">
                Proposal sent
              </h2>
              <p className="text-slate-600 mb-6" data-id="element-1080">
                Erin Park will receive a branded proposal from{' '}
                <span className="font-bold" data-id="element-1081">{brandName}</span> in the next few
                seconds. We'll notify you when it's opened.
              </p>
              <Link to="/dashboard/clients" data-id="element-1082">
                <Button variant="primary" data-id="element-1083">Back to Client Book</Button>
              </Link>
            </motion.div> : <div className="bg-slate-100 rounded-2xl p-6 lg:sticky lg:top-24" data-id="element-1084">
              <div className="flex items-center justify-between mb-4" data-id="element-1085">
                <span className="text-xs font-bold uppercase tracking-wider text-slate-500" data-id="element-1086">
                  Live preview · branded as {brandName}
                </span>
                <span className="text-xs text-slate-400" data-id="element-1087">
                  PDF / email-ready
                </span>
              </div>

              <motion.div key={primary + accent + brandName} initial={{
            opacity: 0,
            y: 8
          }} animate={{
            opacity: 1,
            y: 0
          }} className="bg-white rounded-xl shadow-2xl shadow-slate-300/40 overflow-hidden border border-slate-200" data-id="element-1088">
                {/* Cover */}
                <div className="p-10 text-white relative overflow-hidden" style={{
              backgroundColor: primary
            }} data-id="element-1089">
                  <div className="absolute -top-20 -right-20 w-72 h-72 rounded-full opacity-30 blur-3xl" style={{
                backgroundColor: accent
              }} data-id="element-1090" />
                  <div className="relative z-10" data-id="element-1091">
                    <div className="text-xs font-bold uppercase tracking-[0.25em] mb-3 opacity-80" style={{
                  color: accent
                }} data-id="element-1092">
                      {brandName}
                    </div>
                    <h1 className="text-3xl font-bold mb-3 leading-tight" data-id="element-1093">
                      A proposal for Northwind Capital
                    </h1>
                    <p className="text-sm opacity-80 max-w-md" data-id="element-1094">
                      Q1 Leadership Offsite · Featuring the Offsite+ Premium
                      Experience Layer
                    </p>
                  </div>
                </div>

                {/* Body */}
                <div className="p-8 space-y-6" data-id="element-1095">
                  <section data-id="element-1096">
                    <div className="text-[10px] font-bold uppercase tracking-[0.2em] mb-2" style={{
                  color: accent
                }} data-id="element-1097">
                      Hello Erin
                    </div>
                    <h2 className="text-xl font-bold text-slate-900 mb-2" data-id="element-1098">
                      A retreat designed around your team's intent.
                    </h2>
                    <p className="text-sm text-slate-600 leading-relaxed" data-id="element-1099">
                      Building on Northwind's last three offsites, we've
                      designed a Leadership Reset experience layer that adds
                      structured learning, attendee intake, and a client-ready
                      outcomes report — fully wrapped in {brandName}'s
                      hospitality.
                    </p>
                  </section>

                  <section className="rounded-xl p-5 border" style={{
                borderColor: accent + '40',
                backgroundColor: accent + '08'
              }} data-id="element-1100">
                    <div className="text-xs font-bold uppercase tracking-wider text-slate-500 mb-3" data-id="element-1101">
                      Recommended pathway
                    </div>
                    <div className="text-lg font-bold text-slate-900 mb-1" data-id="element-1102">
                      Leadership Reset · Premium
                    </div>
                    <div className="text-sm text-slate-600" data-id="element-1103">
                      Intake form · Group matching · Module sessions · Wellness
                      layer · Post-event report
                    </div>
                  </section>

                  <section data-id="element-1104">
                    <div className="text-xs font-bold uppercase tracking-wider text-slate-500 mb-3" data-id="element-1105">
                      Sample agenda
                    </div>
                    <div className="space-y-2 text-sm" data-id="element-1106">
                      {[['Day 1 · 16:00', 'Welcome circle & intentions'], ['Day 2 · 09:00', 'Leadership Reset module'], ['Day 2 · 14:00', 'Wellness break · spa or hike'], ['Day 3 · 10:00', 'Commitments & integration']].map(([t, l]) => <div key={l} className="flex gap-4 py-2 border-b border-slate-100 last:border-0" data-id="element-1107">
                          <span className="font-mono text-xs text-slate-500 w-24 shrink-0" data-id="element-1108">
                            {t}
                          </span>
                          <span className="text-slate-700" data-id="element-1109">{l}</span>
                        </div>)}
                    </div>
                  </section>

                  <section className="rounded-xl p-5 text-white" style={{
                backgroundColor: primary
              }} data-id="element-1110">
                    <div className="text-xs font-bold uppercase tracking-wider opacity-70 mb-2" data-id="element-1111">
                      Investment
                    </div>
                    <div className="flex items-end justify-between" data-id="element-1112">
                      <div data-id="element-1113">
                        <div className="text-3xl font-black mb-0.5" data-id="element-1114">
                          $58,400
                        </div>
                        <div className="text-xs opacity-70" data-id="element-1115">
                          For up to 48 attendees · all-inclusive
                        </div>
                      </div>
                      <button className="text-xs font-bold px-3 py-1.5 rounded-full" style={{
                    backgroundColor: accent,
                    color: 'white'
                  }} data-id="element-1116">
                        Accept proposal
                      </button>
                    </div>
                  </section>

                  <div className="text-xs text-slate-400 text-center pt-4 border-t border-slate-100" data-id="element-1117">
                    Powered by Offsite+ · Sent on behalf of {brandName}
                  </div>
                </div>
              </motion.div>
            </div>}
        </div>
      </div>
    </DashboardLayout>;
}